(function () {
  function initSipitProduct(root) {
    if (!root || root.dataset.sipitInit === '1') return;
    root.dataset.sipitInit = '1';

    const mainImg = root.querySelector('[data-sipit-main-img]');
    const mainVid = root.querySelector('[data-sipit-main-vid]');
    const mainVidEl = mainVid?.tagName === 'VIDEO' ? mainVid : mainVid?.querySelector('video');
    const thumbs = root.querySelectorAll('[data-sipit-thumb]');
    const flavs = root.querySelectorAll('[data-sipit-flav]');
    const modes = root.querySelectorAll('[data-sipit-mode]');
    const qInput = root.querySelector('[data-sipit-qty]');
    const qPlus = root.querySelector('[data-sipit-qty-plus]');
    const qMinus = root.querySelector('[data-sipit-qty-minus]');
    const priceNow = root.querySelector('[data-sipit-price-now]');
    const priceWas = root.querySelector('[data-sipit-was]');
    const priceSave = root.querySelector('[data-sipit-save]');
    const btnPrice = root.querySelector('[data-sipit-btn-price]');
    const sbPrice = root.querySelector('[data-sipit-sb-price]');
    const perServe = root.querySelector('[data-sipit-per-serve]');
    const sbTitle = root.querySelector('[data-sipit-sb-title]');
    const variantInput = root.querySelector('[data-sipit-variant-id]');
    const sellingPlanInput = root.querySelector('[data-sipit-selling-plan]');
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const addBtn = root.querySelector('[data-sipit-add-btn]');
    const buyNowBtn = root.querySelector('[data-sipit-buy-now]');
    const buyNowPrice = root.querySelector('[data-sipit-buy-now-price]');
    const sbAdd = root.querySelector('[data-sipit-sb-add]');
    const stickyBar = root.querySelector('[data-sipit-sticky-bar]');
    const servings = parseInt(root.dataset.servings || '15', 10) || 15;

    let activePrice = parseFloat(root.dataset.defaultPrice || '0');
    let adding = false;

    function formatMoney(amount) {
      const symbol = root.dataset.moneyFormat || '$';
      const value = Number.isFinite(amount) ? amount : 0;
      const cents = Math.round(value * 100);
      const formatted = (cents / 100).toFixed(2);
      if (symbol.includes('{{')) {
        return '$' + formatted;
      }
      return symbol.replace(/\{\{\s*amount\s*\}\}/, formatted);
    }

    function isSubscribeMode() {
      const activeMode = root.querySelector('[data-sipit-mode].active');
      return Boolean(activeMode && activeMode.dataset.sellingPlan);
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput) return;
      const activeMode = root.querySelector('[data-sipit-mode].active');
      const planId = activeMode?.dataset.sellingPlan || '';
      sellingPlanInput.value = planId;
      sellingPlanInput.disabled = !planId;
    }

    function refreshPrice() {
      const display = formatMoney(activePrice);
      if (btnPrice) btnPrice.textContent = display;
      if (priceNow) priceNow.textContent = display;
      if (sbPrice) sbPrice.textContent = display;
      if (buyNowPrice) buyNowPrice.textContent = display;
      if (perServe) {
        const per = (activePrice / servings).toFixed(2);
        perServe.textContent = perServe.dataset.template.replace('__PER__', per);
      }

      const subscribe = isSubscribeMode();
      if (priceWas) priceWas.hidden = !subscribe;
      if (priceSave) priceSave.hidden = !subscribe;
    }

    function getCartPayload() {
      syncQty();
      syncSellingPlanInput();
      const variantId = Number(variantInput?.value || 0);
      const quantity = parseInt(qInput?.value || form?.querySelector('input[name="quantity"]')?.value || '1', 10) || 1;
      const sellingPlan = sellingPlanInput && !sellingPlanInput.disabled ? sellingPlanInput.value : '';
      const item = { id: variantId, quantity };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }

    async function addItemToCart(item) {
      const res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart.');
      }
      return data;
    }

    function openCartDrawer() {
      const trigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) {
        trigger.click();
        return;
      }
      window.location.href = '/cart';
    }

    function flashAdded(btn) {
      if (!btn) return;
      const original = btn.innerHTML;
      btn.innerHTML = btn.dataset.addedText || 'Added ✓';
      btn.style.background = 'var(--teal)';
      btn.style.color = '#062a2d';
      setTimeout(() => {
        btn.innerHTML = original;
        btn.style.background = '';
        btn.style.color = '';
      }, 1300);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        const type = thumb.dataset.mediaType;
        if (type === 'video' && mainVidEl) {
          if (mainImg) mainImg.style.display = 'none';
          if (mainVid) mainVid.style.display = 'block';
          mainVidEl.play().catch(() => {});
        } else {
          if (mainVidEl) mainVidEl.pause();
          if (mainVid) mainVid.style.display = 'none';
          if (mainImg) {
            mainImg.style.display = 'block';
            const src = thumb.dataset.src;
            if (src) mainImg.src = src;
          }
        }
      });
    });

    flavs.forEach((flav) => {
      flav.addEventListener('click', () => {
        flavs.forEach((f) => f.classList.remove('active'));
        flav.classList.add('active');

        const variantId = flav.dataset.variantId;
        if (variantInput && variantId) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const name = flav.dataset.flavor || '';
        if (sbTitle && name) {
          sbTitle.textContent =
            name + ' · ' + (root.querySelector('[data-sipit-sb-sub]')?.textContent || 'Subscribe & save');
        }

        const img = flav.dataset.img;
        if (img && mainImg) {
          thumbs.forEach((t) => t.classList.remove('active'));
          const first = root.querySelector('[data-sipit-thumb]');
          if (first) first.classList.add('active');
          if (mainVid) mainVid.style.display = 'none';
          if (mainVidEl) mainVidEl.pause();
          mainImg.style.display = 'block';
          mainImg.src = img;
        }

        const onetimePrice = parseFloat(flav.dataset.price);
        const subscribePrice = parseFloat(flav.dataset.subscribePrice);
        if (priceWas && !Number.isNaN(onetimePrice)) {
          priceWas.textContent = formatMoney(onetimePrice);
        }

        modes.forEach((mode) => {
          const planId = mode.dataset.sellingPlan || '';
          if (planId) {
            if (!Number.isNaN(subscribePrice)) mode.dataset.price = String(subscribePrice);
          } else if (!Number.isNaN(onetimePrice)) {
            mode.dataset.price = String(onetimePrice);
          }
          const modePrice = parseFloat(mode.dataset.price);
          const mp = mode.querySelector('.mp');
          if (mp && !Number.isNaN(modePrice)) mp.textContent = formatMoney(modePrice);
        });

        const activeMode = root.querySelector('[data-sipit-mode].active');
        const activeModePrice = activeMode ? parseFloat(activeMode.dataset.price) : NaN;
        if (!Number.isNaN(activeModePrice)) {
          activePrice = activeModePrice;
          refreshPrice();
        }
        syncSellingPlanInput();

        if (buyNowBtn) buyNowBtn.disabled = flav.hasAttribute('disabled');
        if (addBtn) addBtn.disabled = flav.hasAttribute('disabled');
      });
    });

    modes.forEach((mode) => {
      mode.addEventListener('click', () => {
        modes.forEach((m) => m.classList.remove('active'));
        mode.classList.add('active');

        const price = parseFloat(mode.dataset.price);
        if (!Number.isNaN(price)) {
          activePrice = price;
          refreshPrice();
        }

        syncSellingPlanInput();

        const label = mode.dataset.label || '';
        const sbSub = root.querySelector('[data-sipit-sb-sub]');
        if (sbSub && label) sbSub.textContent = label;
      });
    });

    if (qPlus && qInput) {
      qPlus.addEventListener('click', () => {
        const max = parseInt(qInput.max || '99', 10);
        qInput.value = String(Math.min(max, (parseInt(qInput.value, 10) || 1) + 1));
        syncQty();
      });
    }

    if (qMinus && qInput) {
      qMinus.addEventListener('click', () => {
        const min = parseInt(qInput.min || '1', 10);
        qInput.value = String(Math.max(min, (parseInt(qInput.value, 10) || 1) - 1));
        syncQty();
      });
    }

    if (qInput) {
      qInput.addEventListener('input', () => {
        const min = parseInt(qInput.min || '1', 10);
        const max = parseInt(qInput.max || '99', 10);
        let v = parseInt(String(qInput.value).replace(/\D/g, ''), 10) || min;
        qInput.value = String(Math.min(max, Math.max(min, v)));
        syncQty();
      });
    }

    function syncQty() {
      if (!form || !qInput) return;
      const qtyField = form.querySelector('input[name="quantity"]');
      if (qtyField) qtyField.value = qInput.value;
    }

    async function handleAddToCart(event) {
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (adding || addBtn?.disabled) return;

      const item = getCartPayload();
      if (!item.id) return;

      adding = true;
      if (addBtn) addBtn.disabled = true;

      try {
        await addItemToCart(item);
        flashAdded(addBtn);
        if (sbAdd) flashAdded(sbAdd);
        openCartDrawer();
      } catch (err) {
        window.alert(err.message || 'Could not add to cart.');
      } finally {
        adding = false;
        if (addBtn) addBtn.disabled = false;
      }
    }

    if (sbAdd && addBtn) {
      sbAdd.addEventListener('click', (e) => {
        e.preventDefault();
        handleAddToCart(e);
      });
    }

    if (form) {
      // Capture before Horizon product-form-component so selling_plan is always applied.
      form.addEventListener('submit', handleAddToCart, true);
    }

    if (buyNowBtn && variantInput) {
      buyNowBtn.addEventListener('click', async () => {
        if (buyNowBtn.disabled || adding) return;

        const item = getCartPayload();
        if (!item.id) return;

        buyNowBtn.disabled = true;
        const original = buyNowBtn.innerHTML;
        buyNowBtn.textContent = 'Redirecting…';

        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
          await addItemToCart(item);
          window.location.href = '/checkout';
        } catch {
          buyNowBtn.disabled = false;
          buyNowBtn.innerHTML = original;
        }
      });
    }

    if (stickyBar && addBtn) {
      const footer = document.querySelector('#shopify-section-group-footer-group, footer');
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.target === addBtn) {
              stickyBar.dataset.past = e.isIntersecting ? '0' : '1';
            }
            if (footer && e.target === footer) {
              stickyBar.dataset.foot = e.isIntersecting ? '1' : '0';
            }
            stickyBar.classList.toggle(
              'show',
              stickyBar.dataset.past === '1' && stickyBar.dataset.foot !== '1'
            );
          });
        },
        { threshold: 0 }
      );
      io.observe(addBtn);
      if (footer) io.observe(footer);
    }

    syncSellingPlanInput();
    refreshPrice();
    syncQty();
  }

  function boot() {
    document.querySelectorAll('[data-sipit-pdp]').forEach(initSipitProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-sipit-pdp]');
    if (root) initSipitProduct(root);
  });
})();
